export default {"src":"/_next/static/media/hero_m_orange.9a435a10.svg","height":508,"width":353,"blurWidth":0,"blurHeight":0};